
import { $t } from '@/i18n';
import { CATEGORY } from './const';
import { nodeDiff3Text } from '@/utils/merge/textMerge';
export default [
  {
    id: 'utils:diff3',
    name: $t('k_29468fa1'),
    desc: $t('k_217525ad'),
    category: CATEGORY.LOGIC,
    paramsSchema: {
      type: 'object',
      fields: [
        {
          id: 'origin',
          title: $t('k_215f06fc'),
          type: 'string',
          default: '',
          'uc:allowInterop': true,
        },
        {
          id: 'remote',
          title: $t('k_bebf07a7'),
          type: 'string',
          default: '',
          'uc:allowInterop': true,
        },
        {
          id: 'local',
          title: $t('k_35121f81'),
          type: 'string',
          default: '',
          'uc:allowInterop': true,
        },
        {
          id: 'showTip',
          title: $t('k_6fbaf5d7'),
          type: 'boolean',
          default: '',
          'uc:allowInterop': true,
        },
      ],
    },
    returnValue: {
      description: $t('k_2452e775'),
      type: 'string',
    },
    execute: async (ctx, params) => {
      const { origin, remote, local, showTip } = params;
      try {
        const result = await nodeDiff3Text(origin, remote, local, { type: 'text/plain', showTip, remainEmptyLine: true });
        if (result.success) {
          return result.data;
        }
      } catch (e) {
        throw new Error($t('k_f18f16b8', { arg_0: e.message }));
      }
      throw new Error($t('k_94e9d997'));
    },
  },
];
